import { Modal as EdsModal } from '@eventbrite/valkyrie-eds-modal';
import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

export interface ModalProps {
  children: React.ReactNode;
  visible: boolean;
  title?: string;
  type?: string;
  illustration?: JSX.Element;
  noPadding?: boolean;
  dangerouslySetContainerClassName?: { __className: string };
  noMinHeight?: boolean;
  onClose?: () => void;
  isClosable?: boolean;
  __containerClassName?: string;
}

export const Modal: React.FC<ModalProps> = ({
  visible,
  title,
  children,
  type = 'complex',
  illustration,
  noPadding,
  dangerouslySetContainerClassName,
  noMinHeight = true,
  isClosable = true,
  onClose: notifyClosed,
  __containerClassName,
}) => {
  const modalDiv = useMemo(() => (typeof window !== 'undefined' ? document.createElement('div') : null), []);

  useEffect(() => {
    if (modalDiv) {
      document.body.appendChild(modalDiv);

      return () => {
        modalDiv.remove();
      };
    }
  }, [modalDiv]);

  if (!visible || !modalDiv) return null;

  return ReactDOM.createPortal(
    <EdsModal
      title={title}
      isShown={visible}
      onClose={notifyClosed}
      isClosable={isClosable}
      noMinHeight={noMinHeight}
      type={type}
      illustration={illustration}
      noPadding={noPadding}
      modalBodyIsEmpty={false}
      dangerouslySetContainerClassName={dangerouslySetContainerClassName}
      __containerClassName={__containerClassName}
    >
      {children}
    </EdsModal>,
    modalDiv,
  );
};
